import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./DisableLogs";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import LandingJazzCashRoutes from "./jazzcash";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    {window.location.pathname.includes("/jc") ||
    window.location.pathname.includes("/landing") ? (
      <LandingJazzCashRoutes />
    ) : (
      <App />
    )}
  </Router>,
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
